var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cs from '../_util/classNames';
import CarouselIndicator from './indicator';
import CarouselArrow from './arrow';
import omit from '../_util/omit';
import { isArray } from '../_util/is';
import { ConfigConsumer } from '../ConfigProvider';
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        var _this = _super.call(this, props) || this;
        _this.autoTimer = 0;
        _this.count = 0;
        _this.componentDidUpdate = function (_, prevState) {
            var _a = _this.state, autoPlay = _a.autoPlay, currentIndex = _a.currentIndex, prevIndex = _a.prevIndex, nextIndex = _a.nextIndex;
            if (prevState.currentIndex !== currentIndex) {
                _this.selectIndex(null, currentIndex);
            }
            if (prevState.autoPlay !== _this.state.autoPlay) {
                if (autoPlay) {
                    _this.autoPlay();
                }
                else {
                    _this.pausePlay();
                }
            }
            if (prevIndex !== prevState.prevIndex && nextIndex !== prevState.nextIndex) {
                _this.setState({
                    Run: false,
                });
                setTimeout(function () {
                    !_this.state.Run &&
                        _this.setState({
                            prevIndex: -1,
                            nextIndex: -1,
                            Run: true,
                        });
                }, _this.props.moveSpeed);
            }
        };
        _this.getCount = function () {
            var children = _this.props.children;
            if (!children) {
                return 0;
            }
            if (isArray(children)) {
                return React.Children.count(children);
            }
            return 1;
        };
        _this.formatIndex = function (index) {
            if (index > _this.count - 1) {
                index = _this.count - 1;
            }
            if (index < 0) {
                index = 0;
            }
            return index;
        };
        _this.getPrevIndex = function (Index, num) {
            if (Index === void 0) { Index = _this.state.Index; }
            if (num === void 0) { num = 1; }
            if (!_this.count) {
                return 0;
            }
            var prevIndex = Index - num;
            if (prevIndex < 0) {
                prevIndex = _this.count - 1;
            }
            return prevIndex;
        };
        _this.getNextIndex = function (Index, num) {
            if (Index === void 0) { Index = _this.state.Index; }
            if (num === void 0) { num = 1; }
            if (!_this.count) {
                return 0;
            }
            var nextIndex = Index + num;
            if (nextIndex >= _this.count) {
                nextIndex = 0;
            }
            return nextIndex;
        };
        _this.autoPlay = function () {
            var autoPlay = _this.state.autoPlay;
            if (autoPlay && !_this.autoTimer) {
                var autoPlaySpeed = _this.props.autoPlaySpeed;
                _this.autoTimer = setInterval(function () {
                    _this.move();
                }, autoPlaySpeed);
            }
        };
        _this.pausePlay = function () {
            if (_this.autoTimer) {
                clearInterval(_this.autoTimer);
                _this.autoTimer = null;
            }
        };
        _this.move = function (num, beforeIndex) {
            if (num === void 0) { num = 1; }
            if (beforeIndex === void 0) { beforeIndex = _this.state.Index; }
            if (!_this.state.Run) {
                return;
            }
            if (_this.count <= 1) {
                // 只有1张幻灯片
                return;
            }
            var Index = _this.state.Index;
            var onChange = _this.props.onChange;
            var newIndex = num < 0 ? _this.getPrevIndex(Index, -1 * num) : _this.getNextIndex(Index, num);
            // 后移
            if (num > 0) {
                _this.setState({
                    // 下一个目标元素移到当前元素后
                    nextIndex: newIndex,
                }, function () {
                    setTimeout(function () {
                        _this.setState({
                            // 目标元素移动到current位置，
                            // 原current位置移到前一位
                            prevIndex: beforeIndex,
                            Index: newIndex,
                            nextIndex: -1,
                        }, function () {
                            onChange && onChange(newIndex, beforeIndex);
                            _this.autoPlay();
                        });
                    }, 50);
                });
            }
            else {
                _this.setState({
                    prevIndex: newIndex,
                }, function () {
                    setTimeout(function () {
                        _this.setState({
                            prevIndex: -1,
                            Index: newIndex,
                            nextIndex: beforeIndex,
                        }, function () {
                            onChange && onChange(newIndex, beforeIndex);
                            _this.autoPlay();
                        });
                    }, 50);
                });
            }
        };
        _this.arrowClick = function (e, offset) {
            e && e.persist();
            _this.pausePlay();
            _this.move(offset);
        };
        _this.selectIndex = function (e, num) {
            var index = _this.formatIndex(num);
            if (e && e.preventDefault) {
                e && e.preventDefault();
                if (!e.target.getAttribute('data-index')) {
                    return;
                }
                index = Number(e.target.getAttribute('data-index'));
            }
            var Index = _this.state.Index;
            var offset = index - Index;
            if (offset) {
                _this.pausePlay();
                _this.move(offset);
            }
        };
        _this.mouseHandle = function (e) {
            if (e.type === 'mouseenter') {
                _this.pausePlay();
            }
            else if (e.type === 'mouseleave') {
                _this.autoPlay();
            }
        };
        _this.renderCarousel = function (_a) {
            var getPrefixCls = _a.getPrefixCls;
            var _b = _this.props, className = _b.className, style = _b.style, indicatorType = _b.indicatorType, indicatorPosition = _b.indicatorPosition, direction = _b.direction, showArrow = _b.showArrow, trigger = _b.trigger, indicatorClassName = _b.indicatorClassName, arrowClassName = _b.arrowClassName, moveSpeed = _b.moveSpeed, timingFunc = _b.timingFunc, children = _b.children, rest = __rest(_b, ["className", "style", "indicatorType", "indicatorPosition", "direction", "showArrow", "trigger", "indicatorClassName", "arrowClassName", "moveSpeed", "timingFunc", "children"]);
            var _c = _this.state, Index = _c.Index, prevIndex = _c.prevIndex, nextIndex = _c.nextIndex, autoPlay = _c.autoPlay;
            var prefixCls = getPrefixCls('carousel');
            var classNames = cs(className, prefixCls);
            var sliderClassName = direction === 'vertical' ? prefixCls + "-slider-vertical" : prefixCls + "-slider";
            var childrenLength = React.Children.toArray(children).length;
            return (React.createElement("div", __assign({ className: classNames, style: style }, omit(rest, ['autoPlaySpeed', 'timingFunc', 'currentIndex']), { onMouseEnter: autoPlay ? _this.mouseHandle : function () { }, onMouseLeave: autoPlay ? _this.mouseHandle : function () { } }),
                React.createElement("div", { className: sliderClassName, ref: function (elem) {
                        _this.wrapper = elem;
                    } }, React.Children.map(children, function (child, index) {
                    var _a;
                    var style = child && child.props && child.props.style
                        ? __assign(__assign({}, child.props.style), { transitionTimingFunction: timingFunc, transitionDuration: moveSpeed + "ms" }) : {
                        transitionTimingFunction: timingFunc,
                        transitionDuration: moveSpeed + "ms",
                    };
                    var classNames = cs((_a = {},
                        _a[child.props.className] = child && child.props && child.props.className,
                        _a[prefixCls + "-item-prev"] = index === prevIndex,
                        _a[prefixCls + "-item-next"] = index === nextIndex,
                        _a[prefixCls + "-item-current"] = index === Index,
                        _a));
                    return React.cloneElement(child, {
                        className: classNames,
                        style: style,
                    });
                })),
                indicatorType !== 'never' && childrenLength > 1 && (React.createElement(CarouselIndicator, { count: _this.count, activeIndex: Index, type: indicatorType, position: indicatorPosition, onSelectIndex: function (e) {
                        _this.selectIndex(e);
                    }, trigger: trigger, className: indicatorClassName })),
                showArrow !== 'never' && childrenLength > 1 && (React.createElement(CarouselArrow, { prev: function (e) {
                        _this.pausePlay();
                        _this.arrowClick(e, -1);
                    }, next: function (e) {
                        _this.pausePlay();
                        _this.arrowClick(e, 1);
                    }, direction: direction, showArrow: showArrow, className: arrowClassName }))));
        };
        _this.count = _this.getCount();
        _this.state = {
            Index: _this.formatIndex(props.currentIndex) || 0,
            currentIndex: props.currentIndex || 0,
            prevIndex: -1,
            nextIndex: -1,
            autoPlay: !!props.autoPlay,
            Run: true,
        };
        return _this;
    }
    Carousel.prototype.componentDidMount = function () {
        if (this.state.autoPlay && this.count > 1) {
            this.autoPlay();
        }
    };
    Carousel.getDerivedStateFromProps = function (nextProps, prevState) {
        var nextState = __assign({}, prevState);
        if ('currentIndex' in nextProps && nextProps.currentIndex !== prevState.currentIndex) {
            nextState.currentIndex = nextProps.currentIndex;
        }
        if ('autoPlay' in nextProps && nextProps.autoPlay !== prevState.autoPlay) {
            nextState.autoPlay = nextProps.autoPlay;
        }
        return nextState;
    };
    Carousel.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderCarousel);
    };
    Carousel.displayName = 'Carousel';
    Carousel.defaultProps = {
        autoPlay: false,
        indicatorType: 'line',
        indicatorPosition: 'bottom',
        direction: 'horizontal',
        showArrow: 'always',
        trigger: 'click',
        autoPlaySpeed: 3000,
        moveSpeed: 500,
        timingFunc: 'ease',
    };
    return Carousel;
}(Component));
export default Carousel;
